<script>
import ListSimulatorsComponent from '../../features/lists/ListSimulatorsComponent';
import ModalSimulatorOfficialView from '../modals/ModalSimulatorOfficialView';
import ModalHistorySimulatorSolvedByStudentsView from '../modals/ModalHistorySimulatorSolvedByStudentsView'
import ModalImportView from '../../../shared/views/ModalImportView';


export default {
  name: 'ListSimulatorsView',
  components: {
    'modal-simulator-view': ModalSimulatorOfficialView,
    'modal-history-simulator-solved-students-view': ModalHistorySimulatorSolvedByStudentsView,
    'modal-import': ModalImportView,
  },
  extends: ListSimulatorsComponent,
};
</script>

<template>
  <div class="list-body">
    <el-row :gutter="20" class="section-ctrl">
    <el-col :xs="24" :sm="14" :md="14" :lg="14" :xl="14" class="header-right">
        <el-button-group class="btn-grp-drp">
          <el-button
            type="primary"
            size="small"
            class="btn-primary"
            icon="el-icon-circle-plus"
            :disabled="!onCanCreate(modulePermissions)"
            @click="onCreate"
          >
            Crear Simulador
          </el-button>
          <el-dropdown>
            <el-button
              size="small"
              class="btn-primary-light"
            >
              <i class="fa fa-ellipsis-v" /> <span class="hidden-xs-only">M&aacute;s Opciones</span>
              <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item>
                  <el-button
                    size="small"
                    class="btn-primary-light"
                    icon="el-icon-s-data"
                    :disabled="!onCanRead(modulePermissions)"
                    @click="onShowHistory"
                  >
                    Historial de Resultados
                  </el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button
                    size="small"
                    class="btn-primary-light btn-primary-full"
                    icon="el-icon-upload"
                    :disabled="!onCanCreate(modulePermissions)"
                    @click="onShowImport"
                  >
                    Importar Simulador
                  </el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button
                    size="small"
                    class="btn-primary-light btn-primary-full"
                    :disabled="!onCanRead(modulePermissions)"
                    @click="onExportToExcel()"
                  >
                    <i
                      class="fa fa-file-excel-o"
                      aria-hidden="true"
                    /> Exportar Excel
                  </el-button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
          <el-dropdown
            trigger="click"
            :hide-on-click="false"
            popper-class="filter-dropdown-popper"
          >
            <el-button
              size="small"
              class="btn-primary-light"
            >
              <i
                class="fa fa-filter"
                aria-hidden="true"
              /> <span class="hidden-xs-only">Filtrar Por</span> <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item>
                  <el-select
                    v-model="filterOptions.difficultyLevelFilter"
                    size="small"
                    clearable
                    placeholder="Dificultad..."
                    value-key="id"
                    @change="onAllFilterChange(filterOptions.difficultyLevelFilter.id, 'DifficultyLevel')"
                    @focus="onFocus"
                  >
                    <el-option
                      v-for="item in difficultyLevels"
                      :key="item.id"
                      :label="item.name"
                      :value="item"
                    />
                  </el-select>
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </el-button-group>
    </el-col>
    <el-col :xs="24" :sm="10" :md="10" :lg="10" :xl="10" class="header-left search-inputs-row">
      <el-input
        v-model="searchName"
        size="small"
        placeholder="Buscar nombre..."
        suffix-icon="el-icon-search"
        @keyup.enter="onAllFilterChange(searchName, 'Name')"
      />
    </el-col>    </el-row>
    <el-table
      v-loading="isListLoading"
      :data="collection"
      empty-text="No se encontraron resultados."
      element-loading-spinner="el-icon-loading"
      :element-loading-text="listLoadingMessage"
    >
      <el-table-column
        label="Nombre"
        min-width="300"
        prop="name"
      />
      <el-table-column
        label="¿Publicado?"
        width="150"
        align="center"
      >
        <template #default="scope">
          <el-switch
            v-model="scope.row.isPublic"
            active-color="#13ce66"
            active-text="SI"
            inactive-text="NO"
            disabled
          />
        </template>
      </el-table-column>
      <el-table-column
        label="¿Es Temporizado?"
        width="150"
        align="center"
      >
        <template #default="scope">
          <el-switch
            v-model="scope.row.isTimer"
            active-color="#13ce66"
            active-text="SI"
            inactive-text="NO"
            disabled
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="CREACIÓN"
        :width="140"
        align="center"
      >
        <template #default="scope">
          <el-tag
            type="info"
            effect="plain"
          >
            <i class="el-icon-date" /> {{ formatDate(scope.row.createdAt) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="updatedAt"
        label="ACTUALIZACIÓN"
        :width="140"
        align="center"
      >
        <template #default="scope">
          <el-tag
            v-if="onCheckUpdatedAt(scope.row.updatedAt)"
            type="info"
            effect="plain"
          >
            <i class="el-icon-date" /> {{ formatDate(scope.row.updatedAt) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="OPCIONES"
        :width="160"
        align="center"
        text-align="center"
      >
        <template #default="scope">
          <el-dropdown @command="onChangeItemOptions">
            <el-button size="small">
              <i
                class="fa fa-ellipsis-v"
                aria-hidden="true"
              />
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item
                  :command="{ command: 'edit', item: scope.row }"
                  :disabled="!onCanRead(modulePermissions)"
                >
                  <i
                    class="el-icon-edit"
                    aria-hidden="true"
                  /> Mostrar
                </el-dropdown-item>
                <el-dropdown-item
                  :command="{ command: 'copy', item: scope.row }"
                  :disabled="!onCanRead(modulePermissions)"
                >
                  <i
                    class="el-icon-copy-document"
                    aria-hidden="true"
                  /> Copiar
                </el-dropdown-item>
                <el-dropdown-item
                  :command="{ command: 'delete', item: scope.row }"
                  :disabled="!onCanDelete(modulePermissions)"
                >
                  <i
                    class="el-icon-delete"
                    aria-hidden="true"
                  /> Eliminar
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-model:current-page="currentPage"
      size="small"
      layout="prev, pager, next"
      :page-count="pagination.totalPages"
      @current-change="onPageChange"
    />
    <modal-simulator-view
      v-if="modalItem.isVisible"
      :form-data="item"
      :conf="modalItem"
    />
    <modal-history-simulator-solved-students-view
      v-if="modalHistory.isVisible"
      :conf="modalHistory"
    />
    <modal-import :conf="modalImport" />
  </div>
</template>
